import {Typography} from "@mui/material";

interface ToggleButtonProps {
    checked: boolean;
    setChecked: (checked: boolean) => void;
}

export default function ToggleButton({checked, setChecked}: ToggleButtonProps) {
    return (
        <>
            <Typography
                style={{
                    color: checked ? "rgba(255, 255, 255, 0.50)" : "#FF7044",
                    fontFamily: "Inter",
                    fontSize: ".87rem",
                    fontWeight: 400,
                    lineHeight: "normal",
                    textAlign: "right",
                    cursor: 'pointer',
                }}
                onClick={() => setChecked(false)}
            >
                Windows
            </Typography>

            <label style={{position: "relative", display: "inline-block", width: "24px", height: "12px"}}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                    style={{opacity: 0, width: 0, height: 0}}
                />
                <span
                    style={{
                        position: "absolute",
                        cursor: "pointer",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "#FF7044",
                        borderRadius: "6px",
                        transition: "0.3s",
                    }}
                />
                <span
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: checked ? "15px" : "2px",
                        transform: "translateY(-50%)",
                        width: "7px",
                        height: "7px",
                        backgroundColor: "#000",
                        borderRadius: "50%",
                        transition: "0.3s",
                    }}
                />
            </label>

            <Typography
                style={{
                    color: checked ? "#FF7044" : "rgba(255, 255, 255, 0.50)",
                    fontFamily: "Inter",
                    fontSize: ".87rem",
                    fontWeight: 400,
                    lineHeight: "normal",
                    textAlign: "left",
                    cursor: 'pointer',
                }}
                onClick={() => setChecked(true)}
            >
                MacOS
            </Typography>
        </>
    );
}
